import {
  TOGGLE_TOGGLE_MODAL,
} from '../actions/toggleModalActions';

const initialState = {
  objectIdToToggle: '',
  toggleTrueText: '',
  toggleFalseText: '',
  paramToToggle: {},
  isOpen: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case TOGGLE_TOGGLE_MODAL:
      return {
        ...action.payload,
        isOpen: !state.isOpen,
      };
    default:
      return state;
  }
}
